import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { stepperData } from "../../../../constant/appConstant";
import fetcher from "../../../../dataProvider";
import {
  setLoading,
  setStepData,
  setStepperConfig,
  setToastData,
} from "../../../../redux/slices/customerJourney";
import { setExamRulesData } from "../../../../redux/slices/examDetails";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { StepperData } from "../../../../types/common";
import { getCountryId, getLanguageCode } from "../../../../utils/common";
import OrderCard from "../../../common/Card";
import stylesOwn from "./styles";
import CandidateSummary from "../../../common/CandidateSummary";
import usePageView from "../../../../utils/analytics/usePageView";
import GTM from "../../../../utils/analytics/gtm";

const AppliedSuccessfull = (props: any) => {
  usePageView("Candidate Registered");
  // const { toggleSteps } = props;
  const [examDetails, setExamDetails] = useState<any>(null);
  const [candidateDetails, setCandidateDetails] = useState<any>(null);
  const dispatch = useAppDispatch();
  const examDataStore = useAppSelector((state) => state.examDetails);
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText } = customerJourney;
  const { examRulesData } = examDataStore;
  const [paymentDetails, setPaymentDetails] = useState<any>();
  const [lookupData, setLookupData] = useState<any>();
  const [countryList, setCountryList] = useState<any>();
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const paymentId = params.get("paymentId");
  const [screenLoad, setScreenLoad] = useState<any>(paymentId ? false : true);

  const toggleSteps = () => {
    let temp: string = JSON.stringify(stepperData);
    let data = JSON.parse(temp);
    data = data.map((item: StepperData, index: number) => {
      if (index < 6) {
        item.completed = true;
        return item;
      } else if (6 === index) {
        item.selected = true;
        item.completed = false;
        dispatch(setStepData({ data: item }));
        sessionStorage.setItem("currentStep", JSON.stringify(item));
        return item;
      } else {
        item.selected = false;
        item.completed = false;
        return item;
      }
    });
    dispatch(setStepperConfig({ data: [...data] }));
  };

  const getAppUrl = () => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
  };

  const retryPayment = async () => {
    const id = sessionStorage.getItem("candidateGuid");
    dispatch(setLoading({ loading: true }));
    try {
      const appUrl = getAppUrl();
      const body = {
        PaymentFinishUrl: `${appUrl}/rex-cj/candidateRegistered`,
      };
      const { data } = await fetcher.post(
        `api/processpayment/${id}/payments`,
        body
      );
      dispatch(setLoading({ loading: false }));
      if (data) {
        window.location.href = data?.paymentFinishUrl;
      }
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("error", e);
    }
  };

  const getLookupData = async () => {
    try {
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/LookupData/GetLookupData?languageCode=${languageCode}`
        );
        setLookupData(data);
      }
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("Error ", e);
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const fetchPaymentStatus = async (paymentId: string) => {
    dispatch(setLoading({ loading: true }));
    try {
      const body = {
        paymentguid: paymentId,
      };
      const { data } = await fetcher.post(`api/processpayment/payment`, body);
      if (data) {
        setPaymentDetails(data);
        setScreenLoad(true);
      }
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("error", e);
    }
  };

  const getExamRules = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      let examData: any = sessionStorage.getItem("examDetails");
      examData = JSON.parse(examData);
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/Exam/?languageCode=${languageCode}&id=${examData.examId}&alias=${countryId?.textValue}`
        );
        dispatch(setExamRulesData({ details: data }));
        sessionStorage.setItem("examRulesData", JSON.stringify(data));
      }
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("Error ", e);
      dispatch(setLoading({ loading: false }));
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const getLocationData = async () => {
    try {
      const { data } = await fetcher.get(
        "/api/LookupData/Countries?languageCode=en-GB"
      );
      setCountryList(data);
    } catch (e) {
      console.log("Error ", e);
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  useEffect(() => {
    getLocationData();
    toggleSteps();
    const candidateGuid = sessionStorage.getItem("candidateGuid");
    let data: any = sessionStorage.getItem("examDetails");
    let examRules: any = sessionStorage.getItem("examRulesData");
    let candidateDetails: any = sessionStorage.getItem("candidateDetails");
    data = JSON.parse(data);
    examRules = JSON.parse(examRules);
    candidateDetails = JSON.parse(candidateDetails);
    setExamDetails(data);
    setCandidateDetails(candidateDetails);
    dispatch(setExamRulesData({ details: examRules }));
    GTM.setUserData(candidateDetails);
    if (paymentId) {
      fetchPaymentStatus(paymentId);
      GTM.purchase(data, candidateGuid, "online");
    } else {
      GTM.purchase(data, candidateGuid, "offline");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (pageText && countryList) {
      getExamRules();
      getLookupData();
    }
    //[GP]: Added countryList because getLookupData depends on it - will be great to refactor it to not use conditional useEffect to fetch API data
  }, [pageText, countryList]);

  return (
    screenLoad && (
      <Box sx={stylesOwn.wrapper} my={5} py={3}>
        {paymentId ? (
          <>
            {paymentDetails?.paymentStatus === 30 && (
              <Typography
                fontSize="1.5rem"
                color="secondary.main"
                fontWeight="700"
                textAlign="center"
              >{`${pageText?.labelsMetadata?.paymentsuccessful} ${examDetails?.examName}`}</Typography>
            )}

            {paymentDetails?.paymentStatus !== 30 && (
              <Typography
                fontSize="1.125rem"
                color="secondary.main"
                fontWeight="700"
                textAlign="center"
              >
                <Box
                  fontSize="1.5rem"
                  mb={2}
                  component="p"
                >{`${pageText?.paymentMetadata?.problemProcessingYourOnlinePaymentfor} ${examDetails?.examName}`}</Box>

                <Box color="red" component="p" mb={2}>
                  {
                    pageText?.paymentMetadata
                      ?.sorryYourTransactionHasNotBeensuccessful
                  }
                </Box>

                <Box textAlign="left">
                  {pageText?.labelsMetadata?.paymentstatussentto}{" "}
                  {candidateDetails?.guardianEmail
                    ? candidateDetails?.guardianEmail
                    : candidateDetails?.email}
                </Box>
              </Typography>
            )}
          </>
        ) : (
          <Typography
            color="secondary.main"
            fontSize="2.25rem"
            fontWeight="700"
            textAlign="center"
          >
            {pageText?.textMetadata?.appliedsuccessfully}
          </Typography>
        )}

        {(paymentDetails?.paymentStatus === 30 || !paymentId) && (
          <Box
            onClick={() => {
              navigate("/");
              navigate(0);
            }}
            className="go_to_home__label"
          >
            <ArrowBackIosIcon />
            {pageText?.buttonsMetadata?.gotohome}
          </Box>
        )}

        {!paymentId &&
          examRulesData?.offlinePaymentOptions?.paymentMethods[0]
            ?.instructions && (
            <Paper component={Box} p={2} mt={4} className="green">
              <Box
                sx={{ wordBreak: "break-word" }}
                dangerouslySetInnerHTML={{
                  __html:
                    examRulesData?.offlinePaymentOptions?.paymentMethods[0]
                      ?.instructions,
                }}
              />
            </Paper>
          )}

        {paymentDetails?.paymentStatus === 30 || !paymentId ? (
          <Stack
            mt={{ xs: 2, md: 10 }}
            direction={{ md: "row-reverse" }}
            justifyContent="space-between"
            gap={2}
          >
            <OrderCard examDetails={examDetails} />
            <Paper
              component={Box}
              sx={{ width: { md: "65%" } }}
              p={{ xs: 2, md: 3 }}
            >
              <CandidateSummary
                pageText={pageText}
                candidateDetails={candidateDetails}
                examDetails={examDetails}
                lookupData={lookupData}
                examRulesData={examRulesData}
                showGuardianFields={!!candidateDetails?.guardianfirstName}
              />
            </Paper>
          </Stack>
        ) : (
          paymentId && (
            <Stack
              direction={{ sm: "row" }}
              mt={4}
              justifyContent="center"
              gap={{ xs: 2, sm: 8 }}
            >
              <Button variant="contained" onClick={retryPayment}>
                {pageText?.labelsMetadata?.retrypayment}
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  navigate("/");
                  navigate(0);
                }}
              >
                {pageText?.buttonsMetadata?.gotohome}
              </Button>
            </Stack>
          )
        )}
      </Box>
    )
  );
};

export default AppliedSuccessfull;
